<template>
  <footer class="footer pt-4 pt-md-5">
    <!-- desktop -->
    <b-container class="d-none d-sm-block">
      <b-row class="mb-5">
        <b-col cols="5" class="text-left">
          <b-row>
            <b-col>
              <h4 style="font-weight: 600; font-size: 18px;">Contact Us</h4>
            </b-col>
          </b-row>

          <b-row>
            <b-col style="line-height: 30px;">
              +628 111 774 779<br>
              info@starguides.co<br>
              OnePM Building<br>
              Jalan Gading Serpong Boulevard Kav M5 No.17-18. Tangerang, Banten 15810
            </b-col>
          </b-row>

          <b-row class="mt-5">
            <b-col>
              <h4 style="font-weight: 600; font-size: 18px;">Payment Methods</h4>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="10">
              <b-row>
                <b-col class="m-1 p-1 center-base all payment-partner">
                  <b-img
                    :src="require('@/assets/icon/payment-partner/visa.png')"
                    alt="visa"
                    fluid
                  />
                </b-col>
                <b-col class="m-1 p-1 center-base all payment-partner">
                  <b-img
                    :src="require('@/assets/icon/payment-partner/master.png')"
                    alt="master"
                    fluid
                  />
                </b-col>
                <b-col class="m-1 p-1 center-base all payment-partner">
                  <b-img
                    :src="require('@/assets/icon/payment-partner/jcb.png')"
                    alt="jcb"
                    fluid
                  />
                </b-col>
                <b-col class="m-1 p-1 center-base all payment-partner">
                  <b-img
                    :src="require('@/assets/icon/payment-partner/amex.png')"
                    alt="amex"
                    fluid
                  />
                </b-col>

              </b-row>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="3" class="text-left">
          <h4 style="font-weight: 600; font-size: 18px;">About StarGuides</h4>
          <ul class="list-unstyled text-small"  style="line-height: 30px; font-size: 14px;">
            <li><router-link tag="a" :to="{ name: 'AboutUs'}">About Us</router-link></li>
            <li><router-link tag="a" :to="{ name: 'HowItWorks'}">How It Works</router-link></li>
            <li><router-link tag="a" :to="{ name: 'HowToBook'}">How To Book</router-link></li>
            <li><router-link tag="a" :to="{ name: 'FAQ'}">F.A.Q.</router-link></li>
            <li><router-link tag="a" :to="{ name: 'TermsAndConditionGuider'}">Become Our Guider</router-link></li>
            <li><router-link tag="a" :to="{ name: 'TermsAndCondition'}">Terms & Condition</router-link></li>
            <li><router-link tag="a" :to="{ name: 'PrivacyAndPolicy'}">Privacy Policy</router-link></li>
          </ul>
        </b-col>

        <b-col cols="2" class="text-left">
          <h4 style="font-weight: 600; font-size: 18px;">Service</h4>
          <ul class="list-unstyled text-small"  style="line-height: 30px; font-size: 14px;">
            <li><router-link tag="a" :to="{ name: 'StarX'}">StarX</router-link></li>
            <li><router-link tag="a" :to="{ name: 'StarVan'}">StarVan</router-link></li>
            <li><router-link tag="a" :to="{ name: 'StarGroup'}">StarGroup</router-link></li>
            <li><router-link tag="a" :to="{ name: 'StarRoad'}">StarRoad</router-link></li>
            <li><router-link tag="a" :to="{ name: 'StarTrip'}">StarTrip</router-link></li>
            <li><router-link tag="a" :to="{ name: 'StarPick'}">StarPick</router-link></li>
          </ul>
        </b-col>

        <b-col cols="2" class="text-left">
          <b-row>
            <b-col>
              <h4 style="font-weight: 600; font-size: 18px;">Corporate</h4>
              <ul class="list-unstyled text-small"  style="line-height: 30px; font-size: 14px;">
                <!-- <li><a href="#">Collaboration</a></li> -->
                <li>
                  <router-link :to="{ name: 'Corporate'}">
                    Partnerships
                  </router-link>
                </li>
              </ul>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <h4 style="font-weight: 600; font-size: 18px;">Social Media</h4>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="3" class="p-0">
              <a href="https://www.instagram.com/starguidesco/">
                <b-img
                  :src="require('@/assets/icon/social-media/instagram.png')"
                  alt="Instagram"
                  style="max-width: 30px; margin: 0;"
                  class="cursor-pointer"
                />
              </a>
            </b-col>
            <b-col cols="3" class="p-0">
              <a href="https://www.facebook.com">
                <b-img
                  :src="require('@/assets/icon/social-media/facebook.png')"
                  alt="Facebook"
                  style="max-width: 30px; margin: 0;"
                  class="cursor-pointer"
                />
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <div class="bottom-divider"></div>

      <b-row class="text-center">
        <b-col class="my-3" style="font-size: 14px;">
          &copy; 2019 PT. JIWA MUDA SEJAHTERA
        </b-col>
      </b-row>
    </b-container>

    <!-- mobile -->
    <b-container class="d-block d-sm-none">
      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <h6>About StarGuides</h6>
              <ul class="list-unstyled text-small">
                <li><router-link tag="a" :to="{ name: 'AboutUs'}">About Us</router-link></li>
                <li><router-link tag="a" :to="{ name: 'HowItWorks'}">How It Works</router-link></li>
                <li><router-link tag="a" :to="{ name: 'HowToBook'}">How To Book</router-link></li>
                <li><router-link tag="a" :to="{ name: 'FAQ'}">F.A.Q.</router-link></li>
                <li><router-link tag="a" :to="{ name: 'TermsAndConditionGuider'}">Become Our Guider</router-link></li>
                <li><router-link tag="a" :to="{ name: 'TermsAndCondition'}">Terms & Condition</router-link></li>
                <li><router-link tag="a" :to="{ name: 'PrivacyAndPolicy'}">Privacy Policy</router-link></li>
              </ul>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col>
              <h6>Payment Methods</h6>
            </b-col>
          </b-row>
          <b-row class="ml-0">
            <b-col cols="4" class="m-1 p-1 center-base all payment-partner">
              <b-img
                :src="require('@/assets/icon/payment-partner/visa.png')"
                alt="visa"
                fluid
              />
            </b-col>
            <b-col cols="4" class="m-1 p-1 center-base all payment-partner">
              <b-img
                :src="require('@/assets/icon/payment-partner/master.png')"
                alt="master"
                fluid
              />
            </b-col>
            <b-col cols="4" class="m-1 p-1 center-base all payment-partner">
              <b-img
                :src="require('@/assets/icon/payment-partner/jcb.png')"
                alt="jcb"
                fluid
              />
            </b-col>
            <b-col cols="4" class="m-1 p-1 center-base all payment-partner">
              <b-img
                :src="require('@/assets/icon/payment-partner/amex.png')"
                alt="amex"
                fluid
              />
            </b-col>
          </b-row>
        </b-col>

        <b-col>
          <h6>Service</h6>
          <ul class="list-unstyled text-small">
            <li><router-link tag="a" :to="{ name: 'StarX'}">StarX</router-link></li>
            <li><router-link tag="a" :to="{ name: 'StarVan'}">StarVan</router-link></li>
            <li><router-link tag="a" :to="{ name: 'StarGroup'}">StarGroup</router-link></li>
            <li><router-link tag="a" :to="{ name: 'StarRoad'}">StarRoad</router-link></li>
            <li><router-link tag="a" :to="{ name: 'StarTrip'}">StarTrip</router-link></li>
            <li><router-link tag="a" :to="{ name: 'StarPick'}">StarPick</router-link></li>
          </ul>
        </b-col>

        <!-- <b-col>
          <h6>Corporate</h6>
          <ul class="list-unstyled text-small">
            <li><a href="#">Collaboration</a></li>
            <li><a href="#">Partnership</a></li>
          </ul>
        </b-col> -->
      </b-row>

      <b-row class="mt-4">
        <b-col style="font-size: 14px;">
          +628 111 774 779<br>
          info@starguides.co<br>
          OnePM Building<br>
          Jalan Gading Serpong Boulevard Kav M5 No.17-18. Tangerang, Banten 15810
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="6" style="line-height: 30px;">
          <b-row>
            <b-col>
              <a href="https://www.instagram.com/starguidesco/">
                <b-img
                  :src="require('@/assets/icon/social-media/instagram.png')"
                  alt="Instagram"
                  style="max-width: 25px;"
                  class="cursor-pointer"
                />
              </a>
              <a href="https://www.facebook.com">
                <b-img
                  :src="require('@/assets/icon/social-media/facebook.png')"
                  alt="Facebook"
                  style="max-width: 25px; margin-left: 5px;"
                  class="cursor-pointer"
                />
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <div class="bottom-divider"></div>

      <b-row class="text-center">
        <b-col class="my-3" style="font-size: 14px;">
          &copy; 2019 PT. JIWA MUDA SEJAHTERA
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
// external dependencies

// custom component

// api call

export default {
  name: 'Footer',
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
  .footer {
    background-color: #233c7c !important;
    color: white !important;
  }

  a {
    color: white !important;
  }

  .bottom-divider {
    padding-top: 3em;
    border-top: 1px solid white;
    position: absolute;
    width: 100%;
    left: 0;

    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }

  .payment-partner {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 2px 5px 4px rgba(0, 0, 0, 0.3);
    width: 50px;
    height: 50px;
  }
  .payment-partner > img {
    max-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer/Footer.vue